import React, { useState }  from 'react';
import { useStoreConfigContext } from '/src/providers';
import * as styles from './styles.scss'

const useConfirmation = () => {
    const { translate } = useStoreConfigContext();
    const [isOpen, setIsOpen] = useState({});

    const toggle = params => setIsOpen({ ...isOpen, ...params });

    return ({
        toggleConfirmation: toggle,
        Confirmation: ({ id, onSuccess, disabled }) => isOpen[id] &&
            <div className={styles.confirmation}>
                <div className={styles.hover} />
                <button
                    className={styles.accept}
                    disabled={disabled}
                    onClick={() => {
                        onSuccess();
                        toggle({ [id]: false });
                    }}
                >
                    {translate('Accept')}
                </button>
                <button
                    className={styles.cancel}
                    onClick={() => toggle({ [id]: false })}
                >
                    {translate('Cancel')}
                </button>
            </div>
    });
};

export default useConfirmation;
